module.exports = __webpack_public_path__ + "img/vk_24px.df9fa587.svg";